import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class UpdateFrequencyUserAlertUseCase extends UseCase {
  constructor({config, repository, getCurrentUserService}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._frequencyNotificationData = config.get('alerts').frequencyNotificationData
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'UpdateFrequencyUserAlertUseCase#execute'})
  @inlineError
  async execute({userAlert, frequencyData}) {
    const userEntity = await this._getCurrentUserService.execute()
    const userId = userEntity.getId()
    const {alertId} = userAlert
    const {value} = frequencyData

    const [error, response] = await this._repository.updateFrequencyUserAlert({
      userId,
      alertId,
      frequencyData: this._frequencyNotificationData[value]
    })

    if (error) return Promise.reject(error)

    return response
  }
}

export default UpdateFrequencyUserAlertUseCase
